import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, map, switchMap, tap, filter } from 'rxjs/operators';
import { EventService } from 'src/app/core/services/event.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { FloorModel, PropertyFiltersModel, PropertyModel, PropertyPreviewModel, UnitModel } from '../../models/property.model';
import { PropertySavedFilterApplyEvent } from '../../models/property-saved-filter.model';
import { DevelopmentsService } from '../../services/developments.services';
import { TranslateService } from '@ngx-translate/core';
// Range Slider
import { Options, LabelType } from '@angular-slider/ngx-slider';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { MenuService } from 'src/app/core/services/menu.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EntityService } from 'src/app/pages/entity/services/entity.service';

interface UnitsBlockViewModel {
  id: string;
  name: string;
  units: UnitModel[];
}

@Component({
  selector: 'app-list-developments',
  templateUrl: './list-developments.component.html',
  styleUrls: ['./list-developments.component.scss']
})
export class ListDevelopmentsComponent implements OnInit {

  @ViewChild('button_close_property_filters') closePropertyfiltersRef!: ElementRef;
  @ViewChild('propertyNotesFileInput') propertyNotesFileInput?: ElementRef<HTMLInputElement>;
  breadCrumbItems!: Array<{}>;
  properties!: PropertyModel[];
  hideElement: boolean = true;
  queryField = new FormControl();
  total: number = 0;
  page: number = 1;
  pageSize: number = 10;
  startIndex: number = 1;
  endIndex: number = 10;
  filter: string = '';
  masterSelected!: boolean;
  pathImage = `${environment.apiUrl}${environment.dirPropertiesImages}/`;
  pathUserImage = `${environment.apiUrl}/${environment.dirProfileImage}/`;
  noresult: boolean = false;
  countCheckSelected = 0;
  checkedList: any;
  property: any;
  isOpenModal = false;
  openModaltSubject$!: BehaviorSubject<number>;
  dataToFormInitDetails: any;
  dataToFormInitAddress: any;
  dataToFormInitAreasNearby: any;
  dataToFormInitChar: any;
  dataToFormInitAdvertisement: any;
  dataToFormInitAgents: any;
  dataToFormInitPortals: any;
  statusList: any;
  selectedStatusId: number | null = null;
  hasStatusFilter = false;
  appliedSavedFilterId: string | null = null;
  appliedSavedFilterName: string | null = null;
  activeFilterChips: any[] = [];
  statusFilterLabel = '';
  locationFilterLabel = '';
  propertyTypeFilterLabel = '';
  currentSavedFilterFormValue: Record<string, any> | null = null;
  minPrice = 0;
  maxPrice = 0;
  options!: Options;
  propertyTypes: any = [];
  propertyTypeGroups: Array<{ name: string; items: any[] }> = [];
  conditions: any = [];
  businessStatus: any = [];
  filtersBusinessStatus: any = [];
  ecs: any = [];
  businessTypes: any = [];
  stores: any = [];
  agents: any = [];
  agentsAux: any = [];
  propertiesFiltersForm!: FormGroup;
  countFilters$!: BehaviorSubject<number>;
  countFiltersconditions: number = 0;
  countFiltersBusinessStatus: number = 0;
  countFiltersBusinessTypes: number = 0;
  countFiltersECS: number = 0;
  propertyFilters!: PropertyFiltersModel;
  showPropertyFilerts = false;
  isLoadingList = false;
  isCountPropertyFilters = false;
  totalPropertyFilters = 0;
  canActivateProperties: { available: boolean, quantity: number } = { available: false, quantity: 0 };
  loginUser!: { id?: string, role?: { id?: string, name?: string }, stores?: any[], associatedUsers?: any };
  bkpFiltersForm: any;
  autoReference = false;
  subscriptions: Subscription = new Subscription();
  openProposal: any;
  prospectingId: any;
  @Input()
  portalExportError!: any;
  totalExported: number = 0;
  nabTabActive: number = 1;
  @Input() allData: any;
  @Input() propertyToUpdate: any;
  @Output() propertyUpdateChange = new EventEmitter();
  receiveNotifictionsImagesProcessed!: Subscription
  receiveNotifictionsUnitsProcessed!: Subscription
  receiveNotifictionsImagesProgress!: Subscription
  toastsTitle: any
  toastsText: any
  toastsPercentage: any
  showToasts = false

  sortColumn:
    | 'property'
    | 'units'
    | 'businessType'
    | 'price'
    | 'store'
    | 'status'
    | 'updated'
    | 'createdAt'
    | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';

  propertyToPreview!: PropertyPreviewModel;
  fullPropertyToPreview: any;
  private previewModalRef: NgbModalRef | null = null;
  exportingUnitsFormat: 'excel' | 'pdf' | null = null;
  // Excel das frações (tem "Vendido por"): só MASTER e STORE OPERATOR da loja
  // do empreendimento — o servidor aplica a mesma regra. O PDF é para todos.
  canExportUnitsExcel = false;
  activeSliderId = 'ngb-slide-0';
  pathDocuments = `${environment.apiUrl}${environment.dirPropertiesDocs}/`;
  enablePropertyNotes: boolean = false;
  showMinCommissionPendingFilter: boolean = false;
  propertyNotesExpanded: boolean = false;
  propertyNotesLoading: boolean = false;
  propertyNotesSaving: boolean = false;
  propertyNotes: any[] = [];
  newPropertyNote: string = '';
  /** O que o servidor deixa fazer nas notas do imóvel em preview. */
  propertyNotesAccess: { canRead: boolean; canWrite: boolean } | null = null;
  propertyNoteFilesToUpload: File[] = [];

  // Preview
  floors: FloorModel[] = [];
  unassignedUnits: UnitModel[] = [];
  unitsBlocks: UnitsBlockViewModel[] = [];
  activeUnitsBlockId: string = '';
  draggedUnit: UnitModel | null = null;
  showAddFloorTop: boolean = false;
  showAddFloorBottom: boolean = false;

  districtsAux: any[] = [];
  allDistricts: any[] = [];
  districts: any[] = [];
  counties: any[] = [];
  parish: any[] = [];

  constructor(
    private propertiesService: DevelopmentsService, private eventService: EventService, public translate: TranslateService,
    private formBuilder: FormBuilder, private changeDetectorRef: ChangeDetectorRef, private renderer: Renderer2,
    public permissionsService: PermissionsService, private menuService: MenuService,
    private notificationService: NotificationService, public toastService: ToastService,
    private modalService: NgbModal,
    private entityService: EntityService
  ) {
    this.openModaltSubject$ = new BehaviorSubject<number>(0)
    this.countFilters$ = new BehaviorSubject<number>(0);

  }


  ngOnInit(): void {

    /* BreadCrumb */
    this.breadCrumbItems = [
      { label: 'Properties' },
      { label: 'Properties List', active: true }
    ];
    this.propertyFilters = { page: this.page };
    if (this.portalExportError?.id && this.portalExportError?.status) {
      this.propertyFilters.exportId = this.portalExportError?.id
      this.propertyFilters.isExported = this.portalExportError?.isExported
      this.propertyFilters.status = true
    }
    const { id, role, stores, associatedUsers } = this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores, associatedUsers };
    this.loadEntitySettings();
    this.tabAll();
    this.searchData();
    this.loadData();
    const subscriptionRefresh = this.eventService.subscribe('refresh-properties', () => {
      this.refreshProperties();
    });
    this.subscriptions.add(subscriptionRefresh);

    const subscriptionR = this.eventService.subscribe('is-open-modal-dev', () => {
      this.openModaltSubject$.next(5);
      this.isOpenModal = false;
    });
    this.subscriptions.add(subscriptionR);

    // "Editar imóvel" no preview de uma fração aberta a partir deste preview.
    const closePreviewSub = this.eventService.subscribe('close-dev-preview', () => {
      this.previewModalRef?.dismiss();
    });
    this.subscriptions.add(closePreviewSub);

    const menuSubs = this.eventService.subscribe('open-proposal-dev', data => {
      this.openProposal = data?.proposalId;
      if (data?.property) {
        this.openModal(data.property);
      } else {
        this.errorMsg(this.translate.instant('t-proposal-no-available'));
      }
      this.menuService.setData(null);
    })
    const clearOpenProposal = this.eventService.subscribe('clear-open-proposal', () => setTimeout(() => { this.openProposal = null }));
    // const fractionSub = this.eventService.subscribe('open-fraction-by-dev', id => {
    //   if (id) {
    //     this.propertiesService.findPrevById(id).subscribe(property => {
    //       if (property) {
    //         this.openModal(property);
    //         document.querySelector('.modal-dev')?.classList.remove('show');
    //         document.querySelector('.modal-back-dev')?.classList.remove('show');
    //         const closeSubscribe = this.eventService.subscribe('is-open-modal-properties', value => {
    //           if (value === false) {
    //             closeSubscribe.unsubscribe();
    //             document.querySelector('.modal-dev')?.classList.add('show');
    //             document.querySelector('.modal-back-dev')?.classList.add('show');
    //           }
    //         });
    //       }
    //     });
    //   }
    //   this.menuService.setData(null);
    // })
    this.subscriptions.add(menuSubs);
    // this.subscriptions.add(fractionSub);
    this.subscriptions.add(clearOpenProposal);
  }
  ngAfterViewInit() {
    this.loadJs();
    this.translate.onLangChange.subscribe(() => {
      this.tabAll();
      this.refreshProperties();
    });

    if (!this.receiveNotifictionsImagesProcessed) {
      this.receiveNotifictionsImagesProcessed = this.notificationService.receiveNotifictionsImagesProcessed().subscribe(data => {
        this.refreshProperties()
      })
      this.subscriptions.add(this.receiveNotifictionsImagesProcessed)
    }

    if (!this.receiveNotifictionsUnitsProcessed) {
      this.receiveNotifictionsUnitsProcessed = this.notificationService.receiveNotifictionsUnitsProcessed().subscribe(data => {
        this.refreshProperties()
      })
      this.subscriptions.add(this.receiveNotifictionsUnitsProcessed)
    }

    if (!this.receiveNotifictionsImagesProgress) {
      this.receiveNotifictionsImagesProgress = this.notificationService.receiveNotifictionsImagesProgress().subscribe(data => {
        if (data <= 100) {
          this.showToasts = true
          this.toastsTitle = 'A Processar...'
          this.toastsText = `${data}%`
          this.toastsPercentage = data
          if (data === 100)
            setTimeout(() => {
              this.showToasts = false
              this.toastsTitle = undefined
              this.toastsText = undefined
              this.toastsPercentage = undefined
            }, 500);
        } else {
          this.showToasts = false
          this.toastsTitle = undefined
          this.toastsText = undefined
          this.toastsPercentage = undefined
        }

      })
      this.subscriptions.add(this.receiveNotifictionsImagesProgress)
    }

  }

  loadData() {
    this.propertiesService.canCreateProperties().subscribe(result => {
      this.canActivateProperties = result;
    });
    this.propertyFilters.page = this.page;
    this.propertiesService.getAll(this.propertyFilters)
      .pipe(
        tap(() => this.hideElement = true),
        tap(data => {
          this.total = data.total,
            this.totalPropertyFilters = this.total;
          this.totalExported = data.totalExported;
          if (this.maxPrice === 0) {
            this.maxPrice = data.maxPrice
            this.options = {
              floor: 0,
              ceil: data.maxPrice,
              translate: (value: number, label: LabelType): string => {
                switch (label) {
                  case LabelType.Low:
                    return `<b>Min :</b> ${value}€`;
                  case LabelType.High:
                    return `<b>Max :</b> ${value}€`;
                  default:
                    return "$" + value;
                }
              }
            }
          }
        }),
        map(data => data.properties),
        tap(() => this.paginate()),
        tap(() => this.noresult = false)
      ).subscribe(properties => {
        if (this.dataToFormInitDetails) {
          this.hideElement = false;
        }
        if (this.propertyFilters?.exportId) {
          const totalExp = this.propertyFilters.isExported ? { totalexp: this.total, totalNotexp: this.totalExported } : { totalexp: this.totalExported, totalNotexp: this.total }
          this.eventService.broadcast('total-properties-export', totalExp)
        }

        this.properties = properties;
        if (this.total === 0) {
          this.noresult = true;
        }
        if (this.masterSelected)
          this.masterSelected = false;
        this.isLoadingList = false;

        const menuData = this.menuService.getData();
        if (menuData?.menu === 'proposals') {
          if (menuData && menuData.propertyId) {
            if (menuData.id) {
              this.openProposal = menuData.id;
              let l: any = this.properties.find((property: any) => {
                return property.id === menuData.propertyId;
              });
              if (l) {
                setTimeout(() => {
                  this.openModal(l);
                }, 500)
              } else {
                this.propertiesService.findPrevById(menuData.propertyId).subscribe(property => {
                  if (property) {
                    setTimeout(() => {
                      this.openModal(property);
                    }, 500)
                  }
                });
              }
            } else {
              this.errorMsg(this.translate.instant('t-proposal-no-available'))
            }
          }
          this.menuService.setData(null);
        }
        if (this.propertyToUpdate && this.propertyToUpdate?.id) {
          const propertyUp = this.propertyToUpdate;
          setTimeout(() => {
            this.openModal(propertyUp);
            setTimeout(() => {
              this.propertyToUpdate = null;
              this.propertyUpdateChange.emit(null);
            })
          }, 500);
        }
        this.resetScroll()
      });
  }
  refreshProperties() {
    this.loadData();
  }

  onSort(
    column:
      | 'property'
      | 'units'
      | 'businessType'
      | 'price'
      | 'store'
      | 'status'
      | 'updated'
      | 'createdAt',
  ) {
    if (this.propertyFilters?.highlight) {
      return;
    }

    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.page = 1;
    this.propertyFilters.page = this.page;
    this.propertyFilters.sortColumn = this.sortColumn || undefined;
    this.propertyFilters.sortDirection = this.sortDirection;
    this.isLoadingList = true;
    this.loadData();
  }

  getSortIndicator(
    column:
      | 'property'
      | 'units'
      | 'businessType'
      | 'price'
      | 'store'
      | 'status'
      | 'updated'
      | 'createdAt',
  ) {
    if (this.propertyFilters?.highlight) return '';
    if (this.sortColumn !== column) return '↕';
    return this.sortDirection === 'asc' ? '↑' : '↓';
  }

  countTotalPropertiesFilters() {
    this.propertyFilters.page = this.page;
    this.filtersProperties(true);
    this.isCountPropertyFilters = true;
    this.propertiesService.totalPropertiesFilters(this.propertyFilters)
      .subscribe(data => {
        this.isCountPropertyFilters = false;
        this.totalPropertyFilters = data.total;
      })
  }

  searchData() {
    this.propertyFilters.page = this.page;
    this.queryField.valueChanges
      .pipe(
        map(value => value.trim()),
        debounceTime(200),
        distinctUntilChanged(),
        tap(value => this.propertyFilters.search = value),
        switchMap(value => this.propertiesService.getAll(this.propertyFilters)),
        tap(data => this.total = data.total),
        map(data => data.properties),
        tap(() => this.paginate()),
        tap(() => this.noresult = false)
      ).subscribe(users => {
        if (this.propertyFilters?.exportId) {
          const totalExp = this.propertyFilters.isExported ? { totalexp: this.total, totalNotexp: this.totalExported } : { totalexp: this.totalExported, totalNotexp: this.total }
          this.eventService.broadcast('total-properties-export', totalExp)
        }
        this.properties = users;
        if (this.total === 0) {
          this.noresult = true;
        }
        if (this.masterSelected)
          this.masterSelected = false;
        this.resetScroll()
      });
  }

  /**
  * Form Validation
*/
  initFormPropertiesFilters() {
    const data: any = {};
    if (this.loginUser.role?.name === 'AGENT' || this.loginUser.role?.name === 'STORE OPERATOR')
      data['showNetworkProperties'] = false;
    data['stores'] = null;
    data['propertyTypes'] = null;
    data['websiteStatus'] = false;
    data['websiteHighlight'] = false;
    data['minUsefulArea'] = null;
    data['maxUsefulArea'] = null;
    data['minYearofconstruction'] = null;
    data['maxYearofconstruction'] = null;
    data['minCreatedAt'] = null;
    data['maxCreatedAt'] = null;
    data['minUpdatedAt'] = null;
    data['maxUpdatedAt'] = null;
    data['minValidatedAt'] = null;
    data['maxValidatedAt'] = null;
    data['minPrice'] = this.minPrice;
    data['maxPrice'] = this.maxPrice;
    data['agents'] = null;
    data[`listingAgent`] = false;
    data[`secondaryAgent`] = false;



    for (const condition of this.conditions) {
      data[`condition_${condition.id}`] = false;
    }
    for (const bStatus of this.businessStatus) {
      data[`businessStatus_${bStatus.id}`] = false;
    }

    for (const bTypes of this.businessTypes) {
      data[`businessTypes_${bTypes.id}`] = false;
    }

    for (const ec of this.ecs) {
      data[`ec_${ec.id}`] = false;
    }
    data["district"] = null;
    data["county"] = null;
    data["parish"] = null;
    data["exclusive"] = false;


    this.propertiesFiltersForm = this.formBuilder.group(data)
    this.propertiesFiltersForm.get(`stores`)?.valueChanges.subscribe(data => {

      this.agents = []
      this.propertiesFiltersForm.get(`agents`)?.patchValue([])
      if (Array.isArray(this.propertiesFiltersForm.get(`stores`)?.value) && this.propertiesFiltersForm.get(`stores`)?.value.length > 0) {
        this.agents = this.agentsAux.filter((ag: any) => {
          return ag?.usersStores?.find((st: any) => this.propertiesFiltersForm.get(`stores`)?.value.includes(st?.storeId))
        })
      } else {
        this.agents = this.agentsAux
      }
    })

    this.propertiesFiltersForm.get('showNetworkProperties')?.valueChanges.subscribe((data) => {
      this.getStores(this.loginUser.role?.name, data);
    })

    this.propertiesFiltersForm.get('district')?.valueChanges.subscribe((districtIds: any) => {
      this.counties = [];
      this.parish = [];
      if (districtIds && districtIds.length > 0) {
        const selectedDistricts = this.districts.filter((d: any) => districtIds.includes(d.id));
        selectedDistricts.forEach((d: any) => {
          this.counties.push(...d.counties.map((c: any) => ({ id: c.id, name: c.name, parishs: c.parishs })));
        });
      }
      this.propertiesFiltersForm.patchValue({ county: null, parish: null });
    });

    // Atualiza freguesias ao selecionar concelho
    this.propertiesFiltersForm.get('county')?.valueChanges.subscribe((countyIds: any) => {
      this.parish = [];
      if (countyIds && countyIds.length > 0) {
        const selectedCounties = this.counties.filter((c: any) => countyIds.includes(c.id));
        selectedCounties.forEach((c: any) => {
          this.parish.push(...c.parishs.map((p: any) => ({ id: p.id, name: p.name })));
        });
      }
      this.propertiesFiltersForm.patchValue({ parish: null });
    });

    this.propertiesFiltersForm.valueChanges.subscribe(data => {


      this.countFilters$.next(0);
      Object.entries(data).forEach(([key, val]: any) => {
        if (val === true) {
          let count = this.countFilters$.getValue();
          count++;
          this.countFilters$.next(count);
        }
        if (Array.isArray(val)) {
          let count = this.countFilters$.getValue();
          count += val.length;
          this.countFilters$.next(count);
        }
      });
      if (this.propertiesFiltersForm.get(`minPrice`)?.value !== this.minPrice || this.propertiesFiltersForm.get(`maxPrice`)?.value !== this.maxPrice) {
        let count = this.countFilters$.getValue();
        count++;
        this.countFilters$.next(count);
      }
      if (this.propertiesFiltersForm.get(`minUsefulArea`)?.value !== null || this.propertiesFiltersForm.get(`maxUsefulArea`)?.value !== null) {
        let count = this.countFilters$.getValue();
        count++;
        if (this.propertiesFiltersForm.get(`minUsefulArea`)?.value && this.propertiesFiltersForm.get(`maxUsefulArea`)?.value === null) {
          this.countFilters$.next(count);
        } else if (this.propertiesFiltersForm.get(`maxUsefulArea`)?.value > 0 && this.propertiesFiltersForm.get(`minUsefulArea`)?.value === null) {
          this.countFilters$.next(count);
        } else {
          this.countFilters$.next(count);
        }
        if (this.propertiesFiltersForm.get(`minUsefulArea`)?.value === 0) {
          this.propertiesFiltersForm.patchValue({ minUsefulArea: null })
        }
        if (this.propertiesFiltersForm.get(`maxUsefulArea`)?.value === 0) {
          this.propertiesFiltersForm.patchValue({ maxUsefulArea: null })
        }

      }

      if (this.propertiesFiltersForm.get(`minYearofconstruction`)?.value !== null || this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value !== null) {
        let count = this.countFilters$.getValue();
        count++;



        if (this.propertiesFiltersForm.get(`minYearofconstruction`)?.value && this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value === null) {
          this.countFilters$.next(count);
        } else if (this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value > 0 && this.propertiesFiltersForm.get(`minYearofconstruction`)?.value === null) {
          this.countFilters$.next(count);
        } else {
          this.countFilters$.next(count);
        }
        if (this.propertiesFiltersForm.get(`minYearofconstruction`)?.value === 0) {
          this.propertiesFiltersForm.patchValue({ minYearofconstruction: null })
        }
        if (this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value === 0) {
          this.propertiesFiltersForm.patchValue({ maxYearofconstruction: null })
        }
      }

      if (this.propertiesFiltersForm.get(`minCreatedAt`)?.value || this.propertiesFiltersForm.get(`maxCreatedAt`)?.value) {
        this.countFilters$.next(this.countFilters$.getValue() + 1);
      }

      if (this.propertiesFiltersForm.get(`minUpdatedAt`)?.value || this.propertiesFiltersForm.get(`maxUpdatedAt`)?.value) {
        this.countFilters$.next(this.countFilters$.getValue() + 1);
      }

      if (this.propertiesFiltersForm.get(`minValidatedAt`)?.value || this.propertiesFiltersForm.get(`maxValidatedAt`)?.value) {
        this.countFilters$.next(this.countFilters$.getValue() + 1);
      }

      this.updateQuickFilterState();
    });

    this.countFilters$.asObservable().pipe(debounceTime(100)).subscribe(count => {
      this.countFiltersconditions = 0;
      this.countFiltersBusinessStatus = 0;
      this.countFiltersBusinessTypes = 0;
      this.countFiltersECS = 0;
      for (const condition of this.conditions) {
        if (this.propertiesFiltersForm.get(`condition_${condition.id}`)?.value === true) {
          this.countFiltersconditions++;
        }
      }

      for (const bStatus of this.businessStatus) {
        if (this.propertiesFiltersForm.get(`businessStatus_${bStatus.id}`)?.value === true) {
          this.countFiltersBusinessStatus++;
        }
      }

      for (const bTypes of this.businessTypes) {
        if (this.propertiesFiltersForm.get(`businessTypes_${bTypes.id}`)?.value === true) {
          this.countFiltersBusinessTypes++;
        }
      }

      for (const ec of this.ecs) {
        if (this.propertiesFiltersForm.get(`ec_${ec.id}`)?.value === true) {
          this.countFiltersECS++;
        }
      }

      if (count > 0 && !this.isCountPropertyFilters && !this.isOpenModal) {
        this.countTotalPropertiesFilters();
      } else if (count === 0 && !this.isCountPropertyFilters && !this.isOpenModal) {
        this.countTotalPropertiesFilters();
      }
    })
    this.updateQuickFilterState();
  }
  touch(evt: any) {



    if (this.propertiesFiltersForm.get(`minUsefulArea`)?.value > this.propertiesFiltersForm.get(`maxUsefulArea`)?.value && this.propertiesFiltersForm.get(`maxUsefulArea`)?.value > 0 && this.propertiesFiltersForm.get(`minUsefulArea`)?.value > 0) {
      this.propertiesFiltersForm.patchValue({ maxUsefulArea: this.propertiesFiltersForm.get(`minUsefulArea`)?.value })
    }
    if (this.propertiesFiltersForm.get(`minUsefulArea`)?.value === 0) {
      this.propertiesFiltersForm.patchValue({ minUsefulArea: null })
    }
    if (this.propertiesFiltersForm.get(`maxUsefulArea`)?.value === 0) {
      this.propertiesFiltersForm.patchValue({ maxUsefulArea: null })
    }

    if (this.propertiesFiltersForm.get(`minYearofconstruction`)?.value > this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value && this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value > 0 && this.propertiesFiltersForm.get(`minYearofconstruction`)?.value > 0) {
      this.propertiesFiltersForm.patchValue({ maxYearofconstruction: this.propertiesFiltersForm.get(`minYearofconstruction`)?.value })
    }
    if (this.propertiesFiltersForm.get(`minYearofconstruction`)?.value === 0) {
      this.propertiesFiltersForm.patchValue({ minYearofconstruction: null })
    }
    if (this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value === 0) {
      this.propertiesFiltersForm.patchValue({ maxYearofconstruction: null })
    }

  }
  loadCss() {
    // const dynamicCss = [
    //   { file: "", id: '' },
    // ];

    // for (let i = 0; i < dynamicCss.length; i++) {
    //   const cssLoad: any = document.querySelector(`#${dynamicCss[i].id}`);
    //   if (!cssLoad) {
    //     const node = document.createElement('link');
    //     node.rel = "stylesheet";
    //     node.href = dynamicCss[i].file;
    //     node.id = dynamicCss[i].id;
    //     document.getElementsByTagName('head')[0].appendChild(node);
    //   }
    // }
  }
  loadJs() {
    // const scriptLoad: any = document.querySelector("#bs-js");
    // if (!scriptLoad) {
    const dynamicScripts = [
      { file: "assets/libs/bootstrap/js/bootstrap.bundle.min.js", id: 'bs-js' },
    ];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const scriptLoad: any = document.querySelector(`#${dynamicScripts[i].id}`);
      if (!scriptLoad) {
        const node = document.createElement("script");
        node.src = dynamicScripts[i].file;
        node.type = "text/javascript";
        node.async = true;
        node.id = dynamicScripts[i].id;
        document.body.appendChild(node);
      }
    }
    // }
  }

  openModal(propertyUpdate: any = null) {
    this.tabAgents(propertyUpdate);
    // this.isOpenModal = true;
    // this.property = propertyUpdate;
    // this.eventService.broadcast('modal-create-edit-property', propertyUpdate);
  }

  paginate() {
    this.startIndex = (this.page - 1) * this.pageSize + 1;
    this.endIndex = (this.page - 1) * this.pageSize + this.pageSize;
    if (this.endIndex > this.total) {
      this.endIndex = this.total;
    }
  }
  /**
* Confirmation delete property
*/
  confirm(id: any) {
    Swal.fire({
      title: this.translate.instant('t-m-properties.t-are-you-sure-you-want-to-delete-the-property'),
      //text: 'Deleting your property will remove all of your information from our database.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f46a6a',
      confirmButtonText: this.translate.instant('t-yes'),
      cancelButtonText: this.translate.instant('t-close')
    }).then(result => {
      if (result.value) {
        this.propertiesService.delete(id).subscribe(
          property => {
            this.refreshProperties();
            Swal.fire(
              this.translate.instant('t-m-properties.t-deleted'),
              this.translate.instant('t-m-properties.t-the-property-was-successfully-deleted'),
              'success');
          },
          error => {
            // console.error(error);
            this.errorMsg(this.translate.instant('t-m-properties.t-error-property-deleted'));
          },
          () => { console.log('complete delete property'); }
        );

      }
    });
  }

  deleteMultiple() {
    if (this.checkedList?.length > 0) {
      Swal.fire({
        title: this.translate.instant('t-m-properties.t-are-you-sure-you-want-to-delete-the-property'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        confirmButtonText: this.translate.instant('t-yes'),
        cancelButtonText: this.translate.instant('t-cancel')
      }).then(result => {
        if (result.value) {
          this.propertiesService.deleteByIds(this.checkedList).subscribe(
            () => {
              this.refreshProperties();
              Swal.fire(
                this.translate.instant('t-m-properties.t-deleted'),
                this.translate.instant('t-m-properties.t-properties-have-been-successfully-deleted'),
                'success');
            },
            error => {
              // console.error(error);
              this.errorMsg(this.translate.instant('t-m-properties.t-at-the-moment-it-is-not-possible-to-delete-the-property'));
            },
            () => { this.countCheckSelected = 0; console.log('complete delete properties'); }
          );

        }
      });
    }
  }
  checkUncheckAll(master: boolean) {
    if (master) {
      for (let i = 0; i < this.properties.length; i++) {
        if (!this.properties[i].isProcessing)
          this.properties[i].isSelected = this.masterSelected;
      }
    } else {
      this.masterSelected = false;
    }
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.countCheckSelected = 0;
    this.checkedList = [];
    for (var i = 0; i < this.properties.length; i++) {
      if (this.properties[i].isSelected) {
        this.checkedList.push(this.properties[i].id);
        this.countCheckSelected++;
      }
    }
    if (this.countCheckSelected == this.pageSize)
      this.masterSelected = true;

  }

  createDateFormat(date: any) {
    const d = new Date(date);
    return d.toLocaleString();
  }

  isDateAvailable(date: any) {
    return new Date(date) > new Date();
  }

  /**
* Title sweet alert
* @param errorMsg Msg modal content
*/
  errorMsg(errorMsg: string) {
    Swal.fire({
      title: 'Oops...! Something went Wrong !',
      text: errorMsg,
      icon: 'warning',
      confirmButtonColor: 'rgb(54, 69, 116)',
      confirmButtonText: 'Close'
    });
  }

  priceFormat(propertyPrice: any, symbol: string = '€') {
    if (propertyPrice) {
      let price = propertyPrice.toString().split('.');
      const spaces = (price: any) =>
        String(price).replace(/(?!^)(?=(?:\d{3})+$)/g, ' ');
      const price1 = spaces(price[0]);
      if (price.length > 1) return price1 + ',' + price[1] + ' ' + symbol;

      return price1 + ' ' + symbol;
    } return propertyPrice;
  }
  tabAll() {
    this.propertiesService.getDataForAllTab().subscribe(data => {
      if (this.properties) {
        this.hideElement = false;
      }
      this.allData = data;
      this.dataToFormInitDetails = data.details;
      this.dataToFormInitAddress = data.countries;
      this.dataToFormInitAreasNearby = data.divisionsNearby;
      this.dataToFormInitChar = data.characteristics;
      this.dataToFormInitAdvertisement = data.advertisement;
      this.dataToFormInitAgents = data.agents;
      this.dataToFormInitPortals = { portals: data.portals };

      this.propertyTypes = data.details?.propertyTypes?.filter((pt: any) => pt.description !== '---');
      this.propertyTypeGroups = this.buildPropertyTypeGroups(this.propertyTypes);
      this.stores = data.details?.stores;
      this.conditions = data.details?.conditions?.filter((pt: any) => pt.description !== '---');
      this.businessStatus = data.details?.businessStatus?.filter((bt: any) => bt.description !== '---');
      this.filtersBusinessStatus = data.details?.businessStatus?.filter((bt: any) => bt.description !== '---');
      this.statusList = this.businessStatus;
      this.ecs = data.details?.ec?.filter((e: any) => e.description !== '---');
      this.businessTypes = data.details?.businessTypes?.filter((bt: any) => bt.description !== '---');
      this.prospectingId = data?.details?.prospecting;
      // this.conditions = data.details?.contdi?.filter((pt: any) => pt.description !== '---');
      this.agentsAux = data.agents;
      this.agents = data.agents;
      this.districts = data.details?.locations;
      this.districtsAux = data.details?.locations;
      const act = this.dataToFormInitAdvertisement.options.find((op: any) => op.order === 0);
      if (act) {
        // this.statusList.push({ id: 0, name: "---", order: -1 });
        // this.statusList.push(act);
      }

      const menuData = this.menuService.getData();
      // this.showTabDetails = true;
      this.openModaltSubject$.next(5)
      this.initFormPropertiesFilters();
      this.applyDefaultBusinessStatusFilter();
      this.filtersProperties(true);
      this.refreshProperties();
    });
  }


  tabAgents(property: any) {
    this.property = property;
    if (property) {
      let storeMain = this.dataToFormInitDetails?.stores.find((s: any) => s.isMain === true);
      // if (property) {
      storeMain = property.store
      // }
      let val: number = this.openModaltSubject$.value;
      if (storeMain?.id /*&& val === 5*/) {
        this.propertiesService.getDataForAgents(storeMain.id, '', true).subscribe((data: any) => {
          this.dataToFormInitAgents = data;
          // this.showTabAgents = true;

          // val++;
          // if (val <= 6)
          //   this.openModaltSubject$.next(val)
          // this.property = property;
          setTimeout(() => {
            this.isOpenModal = true;
            this.openModaltSubject$.next(6);
          });

        });
      }
    } else {
      setTimeout(() => {
        this.isOpenModal = true;
        this.openModaltSubject$.next(6);
      });
    }

  }
  changePrice(event: any, isMin = true) {
    if (isMin) {
      this.propertiesFiltersForm.patchValue({ minPrice: event });
    } else {
      this.propertiesFiltersForm.patchValue({ maxPrice: event });
    }
  }
  onChangestatus(event: any) {
    this.clearAppliedSavedFilter();
    const statusId = typeof event === 'object' ? event?.id : event;
    this.selectedStatusId = statusId ?? null;
    this.patchBusinessStatusSelection(statusId);
    this.filtersProperties(true);
    this.updateQuickFilterState();
    this.refreshProperties();
  }

  changeMinCommissionPending(event: Event) {
    this.clearAppliedSavedFilter();
    if (event)
      this.propertyFilters.minimumCommissionPendingValidation = (
        event.target as HTMLInputElement
      ).checked;

    this.updateQuickFilterState();
    this.refreshProperties();
  }

  applySavedPropertyFilter(event: PropertySavedFilterApplyEvent) {
    this.appliedSavedFilterId = event?.filter?.id || null;
    this.appliedSavedFilterName = event?.filter?.name || null;
    const payload = event?.payload || ({ version: 1, filters: {} } as any);
    const filters = this.cloneSavedFilterData(
      payload.filters || {},
    ) as Partial<PropertyFiltersModel>;

    this.page = 1;
    this.propertyFilters = {
      ...filters,
      page: this.page,
    };

    if (this.portalExportError?.id && this.portalExportError?.status) {
      this.propertyFilters.exportId = this.portalExportError.id;
      this.propertyFilters.isExported = this.portalExportError.isExported;
      this.propertyFilters.status = true;
    }

    this.selectedStatusId =
      payload.ui?.selectedStatusId ?? this.resolveStatusIdFromFilters(filters);
    this.sortColumn = (filters['sortColumn'] as any) || null;
    this.sortDirection = filters['sortDirection'] || 'asc';
    this.queryField.patchValue(filters['search'] || '', { emitEvent: false });
    this.applySavedPropertyFilterForm(payload.formValue);
    this.updateQuickFilterState();
    this.loadData();
  }

  applyQuickFilters() {
    this.clearAppliedSavedFilter();
    this.filtersProperties(true);
    this.updateQuickFilterState();
    this.refreshProperties();
  }

  clearAppliedSavedFilter() {
    this.appliedSavedFilterId = null;
    this.appliedSavedFilterName = null;
  }

  private buildActiveFilterChips() {
    const chips: any[] = [];

    if (this.appliedSavedFilterName) {
      chips.push({
        key: 'saved',
        label: `${this.translate.instant('t-saved-filters.t-button')}: ${this.appliedSavedFilterName}`,
        icon: 'ri-bookmark-3-line',
      });
    }

    if (this.hasStatusFilter) {
      chips.push({
        key: 'status',
        label: `${this.translate.instant('t-m-properties.t-status')}: ${this.getStatusFilterLabel()}`,
        icon: 'ri-checkbox-circle-line',
      });
    }

    if (this.propertyFilters?.minimumCommissionPendingValidation === true) {
      chips.push({
        key: 'minimumCommissionPendingValidation',
        label: this.translate.instant('t-developments.t-commission-to-validate'),
        icon: 'ri-percent-line',
      });
    }

    const locationLabel = this.getLocationFilterLabel();
    if (locationLabel) {
      chips.push({
        key: 'location',
        label: `${this.translate.instant('t-m-properties.t-location')}: ${locationLabel}`,
        icon: 'ri-map-pin-line',
      });
    }

    const propertyTypeLabel = this.getSelectedNames(
      this.propertyTypes,
      this.propertiesFiltersForm?.get('propertyTypes')?.value,
      'description',
    );
    if (propertyTypeLabel) {
      chips.push({
        key: 'propertyTypes',
        label: `${this.translate.instant('t-m-properties.t-property-type')}: ${propertyTypeLabel}`,
        icon: 'ri-home-4-line',
      });
    }

    const advancedChips = this.buildAdvancedFilterChips();
    chips.push(...advancedChips);

    const advancedCount = Math.max(
      0,
      (this.countFilters$?.getValue?.() || 0) - this.getVisibleQuickFormCount(),
    );
    const advancedRemainder = Math.max(0, advancedCount - advancedChips.length);
    if (advancedRemainder > 0) {
      chips.push({
        key: 'advanced',
        label: `${this.translate.instant('t-property-quick-filters.t-advanced')}: ${advancedRemainder}`,
        icon: 'ri-filter-3-line',
      });
    }

    return chips;
  }

  private updateQuickFilterState() {
    const selectedBusinessStatusIds = this.getSelectedBusinessStatusIds();
    this.selectedStatusId =
      selectedBusinessStatusIds.length === 1 ? selectedBusinessStatusIds[0] : null;
    this.hasStatusFilter = selectedBusinessStatusIds.length > 0;
    this.statusFilterLabel = this.getStatusFilterLabel();
    this.locationFilterLabel = this.getLocationFilterLabel();
    this.propertyTypeFilterLabel = this.getSelectedNames(
      this.propertyTypes,
      this.propertiesFiltersForm?.get('propertyTypes')?.value,
      'description',
    );
    this.currentSavedFilterFormValue =
      this.propertiesFiltersForm?.getRawValue?.() ||
      this.propertiesFiltersForm?.value ||
      null;
    this.activeFilterChips = this.buildActiveFilterChips();
  }

  removeActiveFilter(chip: any) {
    if (!chip?.key) return;

    if (chip.key === 'saved') {
      this.clearAppliedSavedFilter();
      this.updateQuickFilterState();
      return;
    }

    if (chip.key === 'status') {
      this.clearAppliedSavedFilter();
      this.selectedStatusId = null;
      this.patchBusinessStatusSelection(null);
      this.filtersProperties(true);
      this.updateQuickFilterState();
      this.refreshProperties();
      return;
    }

    if (chip.key === 'minimumCommissionPendingValidation') {
      this.clearAppliedSavedFilter();
      this.propertyFilters.minimumCommissionPendingValidation = false;
      this.updateQuickFilterState();
      this.refreshProperties();
      return;
    }

    if (chip.key === 'location') {
      this.propertiesFiltersForm.patchValue({
        district: null,
        county: null,
        parish: null,
      });
      this.applyQuickFilters();
      return;
    }

    if (chip.key === 'propertyTypes') {
      this.propertiesFiltersForm.patchValue({ propertyTypes: null });
      this.applyQuickFilters();
      return;
    }

    if (chip.remove) {
      this.removeAdvancedFilterChip(chip);
      return;
    }

    if (chip.key === 'advanced') {
      this.resetPropertiesFiltersForm();
      this.applyQuickFilters();
    }
  }

  clearAllActiveFilters() {
    this.clearAppliedSavedFilter();
    this.selectedStatusId = null;
    this.propertyFilters.minimumCommissionPendingValidation = false;
    this.resetPropertiesFiltersForm();
    this.filtersProperties(true);
    this.updateQuickFilterState();
    this.refreshProperties();
  }

  getStatusFilterLabel() {
    const selectedIds = this.getSelectedBusinessStatusIds();
    return (
      this.getSelectedNames(this.statusList, selectedIds, 'description') ||
      this.translate.instant('t-m-properties.t-status')
    );
  }

  getLocationFilterLabel() {
    const parishLabel = this.getSelectedNames(
      this.parish,
      this.propertiesFiltersForm?.get('parish')?.value,
    );
    if (parishLabel) return parishLabel;

    const countyLabel = this.getSelectedNames(
      this.counties,
      this.propertiesFiltersForm?.get('county')?.value,
    );
    if (countyLabel) return countyLabel;

    return this.getSelectedNames(
      this.districts,
      this.propertiesFiltersForm?.get('district')?.value,
    );
  }

  getSelectedNames(items: any[], selectedIds: any, labelKey = 'name') {
    if (!Array.isArray(selectedIds) || selectedIds.length === 0) return '';

    const names = (items || [])
      .filter((item: any) => this.includesQuickFilterValue(selectedIds, item.id))
      .map((item: any) => item[labelKey] || item.name)
      .filter(Boolean);

    if (names.length <= 2) return names.join(', ');

    return `${names.slice(0, 2).join(', ')} +${names.length - 2}`;
  }

  private buildAdvancedFilterChips() {
    const chips: any[] = [];

    this.pushSelectedOptionChips(chips, {
      controlName: 'stores',
      items: this.stores,
      label: this.translate.instant('t-m-properties.t-store'),
      icon: 'ri-store-2-line',
    });
    this.pushSelectedOptionChips(chips, {
      controlName: 'agents',
      items: this.agentsAux,
      label: this.translate.instant('t-m-properties.t-agents'),
      icon: 'ri-user-star-line',
    });
    this.pushBooleanOptionChips(chips, {
      items: this.conditions,
      controlPrefix: 'condition',
      label: this.translate.instant('t-m-properties.t-condition'),
      icon: 'ri-home-gear-line',
      labelKey: 'description',
    });
    this.pushBooleanOptionChips(chips, {
      items: this.businessTypes,
      controlPrefix: 'businessTypes',
      label: this.translate.instant('t-m-properties.t-business-type'),
      icon: 'ri-hand-coin-line',
      labelKey: 'description',
    });
    this.pushBooleanOptionChips(chips, {
      items: this.ecs,
      controlPrefix: 'ec',
      label: this.translate.instant('t-m-properties.t-energetic-certification'),
      icon: 'ri-flashlight-line',
      labelKey: 'description',
    });

    this.pushBooleanControlChip(chips, 'listingAgent', this.translate.instant('t-properties-agents.t-listing-agent'), 'ri-user-location-line');
    this.pushBooleanControlChip(chips, 'secondaryAgent', this.translate.instant('t-properties-agents.t-secondary-agent'), 'ri-user-shared-line');
    this.pushBooleanControlChip(chips, 'exclusive', this.translate.instant('t-exclusives-only'), 'ri-star-line');
    this.pushBooleanControlChip(chips, 'websiteStatus', this.translate.instant('t-published-website'), 'ri-global-line');
    this.pushBooleanControlChip(chips, 'websiteHighlight', this.translate.instant('t-highlighted-website'), 'ri-sparkling-line');

    this.pushRangeChip(chips, {
      key: 'price',
      label: this.translate.instant('t-m-properties.t-price'),
      icon: 'ri-money-euro-circle-line',
      minControl: 'minPrice',
      maxControl: 'maxPrice',
      isActive: () =>
        this.propertiesFiltersForm?.get('minPrice')?.value !== this.minPrice ||
        this.propertiesFiltersForm?.get('maxPrice')?.value !== this.maxPrice,
      reset: { minPrice: this.minPrice, maxPrice: this.maxPrice },
    });
    this.pushRangeChip(chips, {
      key: 'usefulArea',
      label: this.translate.instant('t-m-properties.t-useful-area'),
      icon: 'ri-ruler-line',
      minControl: 'minUsefulArea',
      maxControl: 'maxUsefulArea',
    });
    this.pushRangeChip(chips, {
      key: 'yearofconstruction',
      label: this.translate.instant('t-m-properties.t-year-of-construction'),
      icon: 'ri-calendar-line',
      minControl: 'minYearofconstruction',
      maxControl: 'maxYearofconstruction',
    });
    this.pushRangeChip(chips, {
      key: 'createdAt',
      label: this.translate.instant('t-created-at'),
      icon: 'ri-calendar-event-line',
      minControl: 'minCreatedAt',
      maxControl: 'maxCreatedAt',
      isDate: true,
    });
    this.pushRangeChip(chips, {
      key: 'updatedAt',
      label: this.translate.instant('t-m-properties.t-updated-at'),
      icon: 'ri-refresh-line',
      minControl: 'minUpdatedAt',
      maxControl: 'maxUpdatedAt',
      isDate: true,
    });
    this.pushRangeChip(chips, {
      key: 'validatedAt',
      label: this.translate.instant('t-validated-at'),
      icon: 'ri-shield-check-line',
      minControl: 'minValidatedAt',
      maxControl: 'maxValidatedAt',
      isDate: true,
    });

    return chips;
  }

  private pushSelectedOptionChips(
    chips: any[],
    config: {
      controlName: string;
      items: any[];
      label: string;
      icon: string;
      labelKey?: string;
    },
  ) {
    const selectedIds = this.propertiesFiltersForm?.get(config.controlName)?.value;
    if (!Array.isArray(selectedIds) || selectedIds.length === 0) return;

    selectedIds.forEach((id: any) => {
      const item = (config.items || []).find((option: any) =>
        this.isSameQuickFilterValue(option?.id, id),
      );
      chips.push({
        key: `${config.controlName}:${id}`,
        label: `${config.label}: ${item?.[config.labelKey || 'name'] || item?.description || id}`,
        icon: config.icon,
        remove: { kind: 'arrayValue', controlName: config.controlName, id },
      });
    });
  }

  private pushBooleanOptionChips(
    chips: any[],
    config: {
      items: any[];
      controlPrefix: string;
      label: string;
      icon: string;
      labelKey?: string;
    },
  ) {
    (config.items || []).forEach((item: any) => {
      const controlName = `${config.controlPrefix}_${item.id}`;
      if (this.propertiesFiltersForm?.get(controlName)?.value === true) {
        chips.push({
          key: controlName,
          label: `${config.label}: ${item?.[config.labelKey || 'name'] || item?.description || item?.name}`,
          icon: config.icon,
          remove: { kind: 'booleanControl', controlName },
        });
      }
    });
  }

  private pushBooleanControlChip(
    chips: any[],
    controlName: string,
    label: string,
    icon: string,
  ) {
    if (this.propertiesFiltersForm?.get(controlName)?.value === true) {
      chips.push({
        key: controlName,
        label,
        icon,
        remove: { kind: 'booleanControl', controlName },
      });
    }
  }

  private pushRangeChip(
    chips: any[],
    config: {
      key: string;
      label: string;
      icon: string;
      minControl: string;
      maxControl: string;
      reset?: Record<string, any>;
      isDate?: boolean;
      isActive?: () => boolean;
    },
  ) {
    const minValue = this.propertiesFiltersForm?.get(config.minControl)?.value;
    const maxValue = this.propertiesFiltersForm?.get(config.maxControl)?.value;
    const isActive = config.isActive
      ? config.isActive()
      : minValue !== null || maxValue !== null;

    if (!isActive) return;

    chips.push({
      key: config.key,
      label: `${config.label}: ${this.getRangeFilterLabel(minValue, maxValue, config.isDate)}`,
      icon: config.icon,
      remove: {
        kind: 'controls',
        values:
          config.reset || {
            [config.minControl]: null,
            [config.maxControl]: null,
          },
      },
    });
  }

  private getRangeFilterLabel(minValue: any, maxValue: any, isDate = false) {
    const min = this.formatAdvancedFilterValue(minValue, isDate);
    const max = this.formatAdvancedFilterValue(maxValue, isDate);

    if (min && max) return `${min} - ${max}`;
    if (min) return `>= ${min}`;
    if (max) return `<= ${max}`;
    return this.translate.instant('t-property-quick-filters.t-active');
  }

  private formatAdvancedFilterValue(value: any, isDate = false) {
    if (value === null || value === undefined || value === '') return '';

    if (!isDate) return `${value}`;

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return `${value}`;

    const day = `${date.getDate()}`.padStart(2, '0');
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    return `${day}/${month}/${date.getFullYear()}`;
  }

  private removeAdvancedFilterChip(chip: any) {
    const remove = chip.remove;
    if (!remove) return;

    this.clearAppliedSavedFilter();

    if (remove.kind === 'arrayValue') {
      const current = this.propertiesFiltersForm?.get(remove.controlName)?.value;
      const next = Array.isArray(current)
        ? current.filter((value: any) => !this.isSameQuickFilterValue(value, remove.id))
        : [];
      this.propertiesFiltersForm.patchValue({
        [remove.controlName]: next.length ? next : null,
      });
      this.applyQuickFilters();
      return;
    }

    if (remove.kind === 'booleanControl') {
      this.propertiesFiltersForm.patchValue({ [remove.controlName]: false });
      this.applyQuickFilters();
      return;
    }

    if (remove.kind === 'controls') {
      this.propertiesFiltersForm.patchValue(remove.values || {});
      this.applyQuickFilters();
    }
  }

  getPropertyTypeGroups(): Array<{ name: string; items: any[] }> {
    return this.propertyTypeGroups;
  }

  private buildPropertyTypeGroups(items: any[]): Array<{ name: string; items: any[] }> {
    const groups = (items || []).reduce(
      (acc: Record<string, any[]>, item: any) => {
        const name =
          item.groupDescription && item.groupDescription !== '---'
            ? item.groupDescription
            : 'N/A';
        acc[name] = acc[name] || [];
        acc[name].push(item);
        return acc;
      },
      {},
    );

    return Object.entries(groups).map(([name, items]) => ({
      name,
      items: items as any[],
    }));
  }

  isQuickFormArrayValueSelected(controlName: string, id: any) {
    const value = this.propertiesFiltersForm?.get(controlName)?.value;
    return this.includesQuickFilterValue(value, id);
  }

  onQuickFormArrayValueClick(event: Event, controlName: string, id: any) {
    event.preventDefault();
    event.stopPropagation();
    this.toggleQuickFormArrayValue(controlName, id);
  }

  onQuickPropertyTypeGroupClick(event: Event, group: any) {
    event.preventDefault();
    event.stopPropagation();
    this.togglePropertyTypeGroup(group);
  }

  toggleQuickFormArrayValue(controlName: string, id: any) {
    const control = this.propertiesFiltersForm?.get(controlName);
    if (!control) return;

    const current = Array.isArray(control.value) ? [...control.value] : [];
    const next = this.includesQuickFilterValue(current, id)
      ? current.filter((value) => !this.isSameQuickFilterValue(value, id))
      : [...current, id];

    control.patchValue(next.length ? next : null);
    this.applyQuickFilters();
  }

  isPropertyTypeGroupSelected(group: any) {
    const selected = this.propertiesFiltersForm?.get('propertyTypes')?.value;
    if (!Array.isArray(selected) || !group?.items?.length) return false;

    return group.items.every((item: any) =>
      this.includesQuickFilterValue(selected, item.id),
    );
  }

  getPropertyTypeGroupSelectedCount(group: any) {
    const selected = this.propertiesFiltersForm?.get('propertyTypes')?.value;
    if (!Array.isArray(selected) || !group?.items?.length) return 0;

    return group.items.filter((item: any) =>
      this.includesQuickFilterValue(selected, item.id),
    ).length;
  }

  togglePropertyTypeGroup(group: any) {
    const control = this.propertiesFiltersForm?.get('propertyTypes');
    if (!control || !group?.items?.length) return;

    const current = Array.isArray(control.value) ? [...control.value] : [];
    const groupIds = group.items.map((item: any) => item.id);
    const isSelected = groupIds.every((id: any) =>
      this.includesQuickFilterValue(current, id),
    );
    const next = isSelected
      ? current.filter(
          (id: any) =>
            !groupIds.some((groupId: any) =>
              this.isSameQuickFilterValue(groupId, id),
            ),
        )
      : Array.from(new Set([...current, ...groupIds]));

    control.patchValue(next.length ? next : null);
    this.applyQuickFilters();
  }

  private includesQuickFilterValue(values: any, id: any) {
    return (
      Array.isArray(values) &&
      values.some((value: any) => this.isSameQuickFilterValue(value, id))
    );
  }

  private isSameQuickFilterValue(a: any, b: any) {
    return String(a) === String(b);
  }

  private getVisibleQuickFormCount() {
    const countArray = (key: string) =>
      Array.isArray(this.propertiesFiltersForm?.get(key)?.value)
        ? this.propertiesFiltersForm.get(key)?.value.length
        : 0;

    return (
      countArray('district') +
      countArray('county') +
      countArray('parish') +
      countArray('propertyTypes') +
      this.getSelectedBusinessStatusIds().length
    );
  }

  private applySavedPropertyFilterForm(formValue?: Record<string, any>) {
    if (!this.propertiesFiltersForm || !formValue) return;

    const data = this.cloneSavedFilterData(formValue);
    const county = data['county'] || null;
    const parish = data['parish'] || null;

    this.resetPropertiesFiltersForm();
    this.syncSavedFilterLocations(data['district'], county);
    this.propertiesFiltersForm.patchValue(
      {
        ...data,
        county: null,
        parish: null,
      },
      { emitEvent: true },
    );
    this.syncSavedFilterLocations(data['district'], county);

    setTimeout(() => {
      this.propertiesFiltersForm.patchValue(
        {
          county,
          parish,
        },
        { emitEvent: true },
      );
      this.updateQuickFilterState();
    });
  }

  private syncSavedFilterLocations(
    districtIds: any[] = [],
    countyIds: any[] = [],
  ) {
    this.counties = [];
    this.parish = [];

    if (Array.isArray(districtIds) && districtIds.length > 0) {
      const selectedDistricts = this.districts.filter((district: any) =>
        districtIds.includes(district.id),
      );
      selectedDistricts.forEach((district: any) => {
        this.counties.push(
          ...(district.counties || []).map((county: any) => ({
            id: county.id,
            name: county.name,
            parishs: county.parishs,
          })),
        );
      });
    }

    if (Array.isArray(countyIds) && countyIds.length > 0) {
      const selectedCounties = this.counties.filter((county: any) =>
        countyIds.includes(county.id),
      );
      selectedCounties.forEach((county: any) => {
        this.parish.push(
          ...(county.parishs || []).map((parish: any) => ({
            id: parish.id,
            name: parish.name,
          })),
        );
      });
    }
  }

  private resolveStatusIdFromFilters(filters: Partial<PropertyFiltersModel>) {
    if (Array.isArray(filters?.businessStatus) && filters.businessStatus.length === 1) {
      return filters.businessStatus[0];
    }

    if (filters?.inProspecting === true) {
      return this.businessStatus?.find((status: any) => status?.code === 'PROSPECTING')?.id || null;
    }

    return null;
  }

  private applyDefaultBusinessStatusFilter() {
    if (!this.propertiesFiltersForm) return;

    const availableId = this.getAvailableBusinessStatusId();
    this.selectedStatusId = availableId;
    this.patchBusinessStatusSelection(availableId);
    this.updateQuickFilterState();
  }

  private patchBusinessStatusSelection(statusId: any) {
    if (!this.propertiesFiltersForm) return;

    const data: any = {};
    for (const status of this.businessStatus || []) {
      data[`businessStatus_${status.id}`] = this.isSameQuickFilterValue(status.id, statusId);
    }

    this.propertiesFiltersForm.patchValue(data);
  }

  private getAvailableBusinessStatusId() {
    return this.businessStatus?.find((status: any) => status?.code === 'AVAILABLE')?.id || null;
  }

  private getSelectedBusinessStatusIds() {
    return (this.businessStatus || [])
      .filter((status: any) => this.propertiesFiltersForm?.get(`businessStatus_${status.id}`)?.value === true)
      .map((status: any) => status.id);
  }

  private cloneSavedFilterData<T>(value: T): T {
    return JSON.parse(JSON.stringify(value || {}));
  }

  resetPropertiesFiltersForm() {
    this.propertiesFiltersForm.reset();
    this.propertiesFiltersForm.patchValue({ minPrice: this.minPrice });
    this.propertiesFiltersForm.patchValue({ maxPrice: this.maxPrice });
    this.propertiesFiltersForm.patchValue({
      websiteStatus: false,
      websiteHighlight: false,
    });
    for (const condition of this.conditions) {
      const data: any = {};
      data[`condition_${condition.id}`] = false;
      this.propertiesFiltersForm.patchValue(data);
    }
    for (const bStatus of this.filtersBusinessStatus) {
      const data: any = {};
      data[`businessStatus_${bStatus.id}`] = false;
      this.propertiesFiltersForm.patchValue(data);
    }

    for (const bTypes of this.businessTypes) {
      const data: any = {};
      data[`businessTypes_${bTypes.id}`] = false;
      this.propertiesFiltersForm.patchValue(data);
    }

    for (const ec of this.ecs) {
      const data: any = {};
      data[`ec_${ec.id}`] = false;
      this.propertiesFiltersForm.patchValue(data);
    }
  }
  filtersProperties(isTotalfilters = false) {
    const data: any = {};

    if (Array.isArray(this.propertiesFiltersForm.get(`stores`)?.value) && this.propertiesFiltersForm.get(`stores`)?.value.length > 0) {
      // data['stores'] = this.propertiesFiltersForm.get(`stores`)?.value;
      this.propertyFilters.stores = this.propertiesFiltersForm.get(`stores`)?.value;

    } else {
      this.propertyFilters.stores = undefined;
    }

    if (Array.isArray(this.propertiesFiltersForm.get(`propertyTypes`)?.value) && this.propertiesFiltersForm.get(`propertyTypes`)?.value.length > 0) {
      // data['propertyTypes'] 
      this.propertyFilters.propertyTypes = this.propertiesFiltersForm.get(`propertyTypes`)?.value;
    } else {
      this.propertyFilters.propertyTypes = undefined;
    }

    if (this.propertiesFiltersForm.get(`minUsefulArea`)?.value !== null || this.propertiesFiltersForm.get(`maxUsefulArea`)?.value !== null) {
      // data['usefulArea']
      this.propertyFilters.usefulArea = {
        min: this.propertiesFiltersForm.get(`minUsefulArea`)?.value !== null ? this.propertiesFiltersForm.get(`minUsefulArea`)?.value : 0,
        max: this.propertiesFiltersForm.get(`maxUsefulArea`)?.value
      }
    } else {
      this.propertyFilters.usefulArea = undefined;
    }

    if (this.propertiesFiltersForm.get(`minYearofconstruction`)?.value !== null || this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value !== null) {
      // data['yearofconstruction']
      this.propertyFilters.yearofconstruction = {
        min: this.propertiesFiltersForm.get(`minYearofconstruction`)?.value !== null ? this.propertiesFiltersForm.get(`minYearofconstruction`)?.value : 0,
        max: this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value
      }
    } else {
      this.propertyFilters.yearofconstruction = undefined;
    }

    if (this.propertiesFiltersForm.get(`minCreatedAt`)?.value || this.propertiesFiltersForm.get(`maxCreatedAt`)?.value) {
      this.propertyFilters.createdAt = {
        min: this.propertiesFiltersForm.get(`minCreatedAt`)?.value || undefined,
        max: this.propertiesFiltersForm.get(`maxCreatedAt`)?.value || undefined,
      };
    } else {
      this.propertyFilters.createdAt = undefined;
    }

    if (this.propertiesFiltersForm.get(`minUpdatedAt`)?.value || this.propertiesFiltersForm.get(`maxUpdatedAt`)?.value) {
      this.propertyFilters.updatedAt = {
        min: this.propertiesFiltersForm.get(`minUpdatedAt`)?.value || undefined,
        max: this.propertiesFiltersForm.get(`maxUpdatedAt`)?.value || undefined,
      };
    } else {
      this.propertyFilters.updatedAt = undefined;
    }

    if (this.propertiesFiltersForm.get(`minValidatedAt`)?.value || this.propertiesFiltersForm.get(`maxValidatedAt`)?.value) {
      this.propertyFilters.validatedAt = {
        min: this.propertiesFiltersForm.get(`minValidatedAt`)?.value || undefined,
        max: this.propertiesFiltersForm.get(`maxValidatedAt`)?.value || undefined,
      };
    } else {
      this.propertyFilters.validatedAt = undefined;
    }

    if (this.propertiesFiltersForm.get(`minPrice`)?.value !== this.minPrice || this.propertiesFiltersForm.get(`maxPrice`)?.value !== this.maxPrice) {
      // data['price']
      this.propertyFilters.price = {
        min: this.propertiesFiltersForm.get(`minPrice`)?.value !== null ? this.propertiesFiltersForm.get(`minPrice`)?.value : 0,
        max: this.propertiesFiltersForm.get(`maxPrice`)?.value
      }
    } else {
      this.propertyFilters.price = undefined;
    }
    const dataFormC = this.conditions.filter((e: any) => {
      return this.propertiesFiltersForm.get(`condition_${e.id}`)?.value === true;
    });
    if (dataFormC?.length > 0) {
      // data['conditions']
      this.propertyFilters.conditions = dataFormC.map((e: any) => e.id); //map

    } else {
      this.propertyFilters.conditions = undefined;
    }
    const dataFormBs = this.businessStatus.filter((e: any) => {
      return this.propertiesFiltersForm.get(`businessStatus_${e.id}`)?.value === true;
    });
    if (dataFormBs?.length > 0) {
      // data['businessStatus']
      this.propertyFilters.businessStatus = dataFormBs.map((e: any) => e.id);
    } else {
      this.propertyFilters.businessStatus = undefined;
    }
    const dataFormBt = this.businessTypes.filter((e: any) => {
      return this.propertiesFiltersForm.get(`businessTypes_${e.id}`)?.value === true;
    });
    if (dataFormBt?.length > 0) {
      // data['businessTypes']
      this.propertyFilters.businessTypes = dataFormBt.map((e: any) => e.id);
    } else {
      this.propertyFilters.businessTypes = undefined;
    }
    const dataFormEC = this.ecs.filter((e: any) => {
      return this.propertiesFiltersForm.get(`ec_${e.id}`)?.value === true;
    });
    if (dataFormEC?.length > 0) {
      // data['ecs']
      this.propertyFilters.ecs = dataFormEC.map((e: any) => e.id);
    } else {
      this.propertyFilters.ecs = undefined;
    }

    if (this.propertiesFiltersForm.get(`showNetworkProperties`)) {
      this.propertyFilters.showNetworkProperties = this.propertiesFiltersForm.get(`showNetworkProperties`)?.value;
    } else {
      this.propertyFilters.showNetworkProperties = undefined;
    }

    if (Array.isArray(this.propertiesFiltersForm.get(`agents`)?.value) && this.propertiesFiltersForm.get(`agents`)?.value.length > 0) {

      this.propertyFilters.agents = this.propertiesFiltersForm.get(`agents`)?.value;

    } else {
      this.propertyFilters.agents = undefined;
    }

    if (this.propertiesFiltersForm.get(`listingAgent`)?.value === true) {
      this.propertyFilters.listingAgent = this.propertiesFiltersForm.get(`listingAgent`)?.value;
    } else {
      this.propertyFilters.listingAgent = undefined;
    }

    if (this.propertiesFiltersForm.get(`secondaryAgent`)?.value === true) {
      this.propertyFilters.secondaryAgent = this.propertiesFiltersForm.get(`secondaryAgent`)?.value;
    } else {
      this.propertyFilters.secondaryAgent = undefined;
    }

    if (this.propertiesFiltersForm.get('district')?.value && this.propertiesFiltersForm.get('district')?.value?.length > 0) {
      this.propertyFilters.district =
        this.propertiesFiltersForm.get('district')?.value;
    } else {
      this.propertyFilters.district = undefined;
    }

    if (this.propertiesFiltersForm.get('county')?.value && this.propertiesFiltersForm.get('county')?.value?.length > 0) {
      this.propertyFilters.county =
        this.propertiesFiltersForm.get('county')?.value;
    } else {
      this.propertyFilters.county = undefined;
    }

    if (this.propertiesFiltersForm.get('parish')?.value && this.propertiesFiltersForm.get('parish')?.value?.length > 0) {
      this.propertyFilters.parish =
        this.propertiesFiltersForm.get('parish')?.value;
    } else {
      this.propertyFilters.parish = undefined;
    }

    if (this.propertiesFiltersForm.get('exclusive')?.value) {
      this.propertyFilters.exclusive =
        this.propertiesFiltersForm.get('exclusive')?.value;
    } else {
      this.propertyFilters.exclusive = undefined;
    }

    if (
      this.portalExportError?.status ||
      this.propertiesFiltersForm.get('websiteStatus')?.value === true
    ) {
      this.propertyFilters.status = true;
    } else {
      this.propertyFilters.status = undefined;
    }

    if (this.propertiesFiltersForm.get('websiteHighlight')?.value === true) {
      this.propertyFilters.highlight = true;
    } else {
      this.propertyFilters.highlight = undefined;
    }

    if (!isTotalfilters) {
      this.closeFilters(false);
      this.refreshProperties();
    }
  }

  closeFilters(isReset = true) {
    this.closePropertyfiltersRef.nativeElement.click();
    setTimeout(() => {
      // if (isReset && this.countFilters$.getValue() === 0)
      //   this.resetPropertiesFiltersForm();
      this.showPropertyFilerts = false;
    }, 100);
  }

  openFilters() {
    this.bkpFiltersForm = this.propertiesFiltersForm.value;
  }

  closeCanvas(el: HTMLElement | null, whitoutFilter: boolean = false) {
    this.showPropertyFilerts = false;
    if (el) {
      el.click();
    } else {
      document.getElementById('closeCBtn')?.click();
    }
    if (whitoutFilter) {
      this.propertiesFiltersForm.setValue(this.bkpFiltersForm);
    }
  }


  drop(event: CdkDragDrop<string[]>) {
    const bProp = this.properties.map(p => p);
    moveItemInArray(this.properties, event.previousIndex, event.currentIndex);
    const data: any[] = [];
    this.properties.forEach((p, i) => {
      data.push({ id: p.id, order: (i + 1) });
    });
    if (data.length > 0) {
      this.propertiesService.updatePropertiesOrder(data).subscribe({
        next: () => {

        },
        error: () => {
          this.properties = bProp;
          this.errorMsg('');
        }
      })
    }
  }
  private resetScroll() {
    setTimeout(() => {
      if (this.portalExportError?.status) {
        const modalElement = document.querySelector('.modal-body');
        if (modalElement) {
          modalElement.scrollTop = 0;
        }
      } else {
        window.scrollTo(0, 0);
      }
    });
  }

  onImageError(event: any) {
    event.target.src = 'assets/images/no-image-available1_1.jpeg';
  }
  onUserImageError(event: any) {
    event.target.src = 'assets/images/users/user-dummy-img.jpg';
  }
  toastClosed() {
    this.toastsTitle = ""
    this.toastsText = ""
    this.toastsPercentage = 0
    this.showToasts = false
  }

  openPreviewModal(content: any, property: any) {
    this.propertyToPreview = property?.preview;
    this.activeUnitsBlockId = '';
    this.initializeBuildingView();
    this.fullPropertyToPreview = property;
    const roleName = this.loginUser?.role?.name;
    this.canExportUnitsExcel =
      roleName === 'MASTER' ||
      (roleName === 'STORE OPERATOR' &&
        (this.loginUser?.stores ?? []).includes(property?.store?.id));
    this.resetPropertyNotesState();
    this.loadPropertyNotesAccess();
    const modalRef = this.modalService.open(content, { size: "xl", centered: true, scrollable: true, backdrop: "static" });
    this.previewModalRef = modalRef;
    modalRef.hidden.subscribe(() => {
      if (this.previewModalRef === modalRef) this.previewModalRef = null;
    });
  }

  editPropertyByPreview() {
    this.openModal(this.fullPropertyToPreview);
  }

  exportUnits(format: 'excel' | 'pdf') {
    const id = this.getCurrentPreviewPropertyId();
    if (!id || this.exportingUnitsFormat) return;

    this.exportingUnitsFormat = format;
    const request$ =
      format === 'pdf'
        ? this.propertiesService.exportUnitsPdf(id)
        : this.propertiesService.exportUnitsExcel(id);
    const exportSub = request$
      .pipe(finalize(() => (this.exportingUnitsFormat = null)))
      .subscribe({
        next: (blob: Blob) => {
          const reference = this.propertyToPreview?.reference || id;
          const date = new Date().toISOString().slice(0, 10);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `fracoes_${reference}_${date}.${format === 'pdf' ? 'pdf' : 'xlsx'}`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        },
        error: () => {
          Swal.fire({
            icon: 'error',
            title: this.translate.instant('t-error-creating')
          });
        }
      });
    this.subscriptions.add(exportSub);
  }

  private loadEntitySettings() {
    this.entityService.getEntityForProposal().subscribe({
      next: (entity) => {
        this.enablePropertyNotes = !!entity?.enablePropertyNotes;
        this.showMinCommissionPendingFilter =
          this.permissionsService.isRealMaster(this.loginUser?.role?.name) &&
          Number(entity?.minimumSaleCommission) > 0 &&
          entity?.minimumCommissionViolationAction ===
            'SEND_TO_MASTER_VALIDATION';
      },
    });
  }

  togglePropertyNotes() {
    if (!this.enablePropertyNotes) return;

    this.propertyNotesExpanded = !this.propertyNotesExpanded;
    if (this.propertyNotesExpanded && this.propertyNotes.length === 0) {
      this.loadPropertyNotes();
    }
  }

  addPropertyNote() {
    const propertyId = this.getCurrentPreviewPropertyId();
    const description = this.newPropertyNote?.trim();
    const hasFiles = this.propertyNoteFilesToUpload.length > 0;

    if (!propertyId || (!description && !hasFiles) || this.propertyNotesSaving) return;

    const formData = new FormData();
    if (description) {
      formData.append('description', description);
    }

    this.propertyNoteFilesToUpload.forEach((file) => {
      formData.append('files', file, file.name);
    });

    this.propertyNotesSaving = true;
    this.propertiesService.createPropertyNote(propertyId, formData).subscribe({
      next: (note) => {
        this.newPropertyNote = '';
        this.propertyNoteFilesToUpload = [];
        this.clearPropertyNoteFilesInput();
        this.propertyNotes.unshift(note);
        this.propertyNotesSaving = false;
      },
      error: () => {
        this.propertyNotesSaving = false;
        this.errorMsg(this.translate.instant('t-something-wrong'));
      },
    });
  }

  formatPropertyNoteDate(date: any) {
    return date ? new Date(date).toLocaleString('pt-PT') : '-';
  }

  onPropertyNoteFilesSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = Array.from(target?.files || []);
    this.propertyNoteFilesToUpload = files;
  }

  getPropertyNoteFileUrl(note: any, file: any) {
    const propertyId = note?.propertyId || this.getCurrentPreviewPropertyId();
    if (!propertyId || !file?.fileName) return null;
    return `${environment.apiUrl}/properties/${propertyId}/notes/files/${encodeURIComponent(file.fileName)}`;
  }

  private loadPropertyNotes() {
    const propertyId = this.getCurrentPreviewPropertyId();
    if (!propertyId) {
      this.errorMsg(this.translate.instant('t-something-wrong'));
      return;
    }

    this.propertyNotesLoading = true;
    this.propertiesService.getPropertyNotes(propertyId).subscribe({
      next: (notes) => {
        this.propertyNotes = notes ?? [];
        this.propertyNotesLoading = false;
      },
      error: () => {
        this.propertyNotesLoading = false;
        this.errorMsg(this.translate.instant('t-something-wrong'));
      },
    });
  }

  private getCurrentPreviewPropertyId() {
    return this.fullPropertyToPreview?.id ?? (this.propertyToPreview as any)?.propertyId;
  }

  private resetPropertyNotesState() {
    this.propertyNotesExpanded = false;
    this.propertyNotesLoading = false;
    this.propertyNotesSaving = false;
    this.propertyNotes = [];
    this.newPropertyNote = '';
    this.propertyNoteFilesToUpload = [];
    this.propertyNotesAccess = null;
    this.clearPropertyNoteFilesInput();
  }

  /** Ver `ListComponent.loadPropertyNotesAccess`: esconde o bloco de notas onde o servidor ia recusar. */
  private loadPropertyNotesAccess() {
    const propertyId = this.getCurrentPreviewPropertyId();
    if (!propertyId) return;

    this.propertiesService.getPropertyNotesAccess(propertyId).subscribe({
      next: (access) => {
        if (this.getCurrentPreviewPropertyId() !== propertyId) return;
        this.propertyNotesAccess = access ?? { canRead: false, canWrite: false };
      },
      error: () => {
        if (this.getCurrentPreviewPropertyId() !== propertyId) return;
        this.propertyNotesAccess = { canRead: false, canWrite: false };
      },
    });
  }

  private clearPropertyNoteFilesInput() {
    if (this.propertyNotesFileInput?.nativeElement) {
      this.propertyNotesFileInput.nativeElement.value = '';
    }
  }

  initializeBuildingView() {
    const previewUnits = this.propertyToPreview?.units || [];
    const blocksMap = new Map<string, UnitsBlockViewModel>();

    previewUnits.forEach((unit: UnitModel) => {
      const blockInfo = this.getUnitBlockInfo(unit);
      if (!blocksMap.has(blockInfo.id)) {
        blocksMap.set(blockInfo.id, { ...blockInfo, units: [] });
      }
      blocksMap.get(blockInfo.id)!.units.push(unit);
    });

    this.unitsBlocks = Array.from(blocksMap.values()).sort((a, b) =>
      a.name.localeCompare(b.name),
    );

    if (this.unitsBlocks.length === 0) {
      this.unitsBlocks = [{ id: '__no_block__', name: 'Sem bloco', units: [] }];
    }

    const hasActiveBlock = this.unitsBlocks.some(
      (block) => block.id === this.activeUnitsBlockId,
    );
    this.activeUnitsBlockId = hasActiveBlock
      ? this.activeUnitsBlockId
      : this.unitsBlocks[0].id;

    this.updateFloorsFromActiveBlock();
  }

  getUnitBlockInfo(unit: UnitModel): { id: string; name: string } {
    const blockData: any = unit?.block ?? unit?.developmentBlock;

    if (blockData && typeof blockData === 'object') {
      const name = (blockData?.name || '').toString().trim();
      const normalizedId = blockData?.id ?? name ?? '__no_block__';
      return {
        id: String(normalizedId),
        name: name || `Bloco ${String(normalizedId)}`,
      };
    }

    if (typeof blockData === 'string' && blockData.trim()) {
      const blockName = blockData.trim();
      return { id: blockName, name: blockName };
    }

    return { id: '__no_block__', name: 'Sem bloco' };
  }

  setActiveUnitsBlock(blockId: string) {
    if (!blockId || this.activeUnitsBlockId === blockId) return;

    this.activeUnitsBlockId = blockId;
    this.draggedUnit = null;
    this.showAddFloorTop = false;
    this.showAddFloorBottom = false;

    this.updateFloorsFromActiveBlock();
  }

  updateFloorsFromActiveBlock() {
    const activeBlock = this.unitsBlocks.find(
      (block) => block.id === this.activeUnitsBlockId,
    );
    const units = activeBlock?.units || [];

    const floorMap = new Map<number, UnitModel[]>();
    const unassigned: UnitModel[] = [];

    units.forEach((unit: UnitModel) => {
      if (
        unit.floor !== null &&
        unit.floor !== undefined &&
        !isNaN(Number(unit.floor))
      ) {
        if (!floorMap.has(unit.floor)) {
          floorMap.set(unit.floor, []);
        }
        floorMap.get(unit.floor)!.push(unit);
      } else {
        unassigned.push(unit);
      }
    });

    this.floors = Array.from(floorMap.entries())
      .sort((a, b) => b[0] - a[0])
      .map(([floorNumber, floorUnits]) => ({
        floorNumber: Number(floorNumber),
        units: floorUnits.sort((a, b) =>
          (a.reference || '').localeCompare(b.reference || ''),
        ),
      }));

    this.unassignedUnits = unassigned.sort((a, b) =>
      (a.reference || '').localeCompare(b.reference || ''),
    );

    if (this.floors.length === 0) {
      this.floors = [{ floorNumber: 0, units: [] }];
    }
  }

  // Verificar se existe piso 0
  hasGroundFloor(): boolean {
    return this.floors.some(f => f.floorNumber === 0);
  }

  // Drag and Drop handlers
  onDragStart(event: DragEvent, unit: UnitModel) {
    this.draggedUnit = unit;
    event.dataTransfer!.effectAllowed = 'move';
    event.dataTransfer!.setData('text/html', (event.target as HTMLElement).innerHTML);

    // Adicionar classe visual ao elemento arrastado
    (event.target as HTMLElement).style.opacity = '0.5';
  }

  onDragEnd(event: DragEvent) {
    this.draggedUnit = null;
    this.showAddFloorTop = false;
    this.showAddFloorBottom = false;

    // Remover classe visual
    (event.target as HTMLElement).style.opacity = '1';
  }

  onDragOver(event: DragEvent) {
    if (!this.draggedUnit) return;
    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer!.dropEffect = 'move';
  }

  onDropOnFloor(event: DragEvent, floor: FloorModel) {
    event.preventDefault();
    if (!this.draggedUnit) return;

    const bkpData = this.draggedUnit;
    const oldFloor = this.floors.find(f => f.floorNumber === bkpData?.floor);
    const oldFloorUnits = oldFloor ? [...oldFloor.units] : [];

    // Remover unit da posição anterior
    this.removeUnitFromCurrentPosition(this.draggedUnit);

    // Adicionar ao novo andar
    this.draggedUnit.floor = floor.floorNumber;
    floor.units.push(this.draggedUnit);
    floor.units.sort((a, b) => (a.reference || '').localeCompare(b.reference || ''));

    this.propertiesService.updateUnitFloor(this.draggedUnit.id, floor.floorNumber).subscribe({
      next: () => {
        this.draggedUnit = null;
      },
      error: () => {
        // Restaurar unit para o piso anterior
        if (oldFloor) {
          oldFloor.units = oldFloorUnits;
          const unitIndex = floor.units.findIndex(u => u.id === bkpData.id);
          if (unitIndex > -1) {
            floor.units.splice(unitIndex, 1);
          }
        } else {
          // Se não havia piso anterior, mover para não atribuídos
          const unitIndex = floor.units.findIndex(u => u.id === bkpData.id);
          if (unitIndex > -1) {
            floor.units.splice(unitIndex, 1);
          }
          this.draggedUnit!.floor = undefined;
          this.unassignedUnits.push(this.draggedUnit as any);
          this.unassignedUnits.sort((a, b) =>
            (a.reference || '').localeCompare(b.reference || '')
          );
        }

        this.draggedUnit = null;

        Swal.fire({
          icon: 'error',
          title: this.translate.instant('t-property-preview.t-error-updating-unit-floor')
          // text: this.translate.instant('t-m-properties.t-error-updating-unit-floor')
        });
      }
    });
  }

  onDropOnUnassigned(event: DragEvent) {
    event.preventDefault();
    if (!this.draggedUnit) return;

    // Remover unit da posição anterior
    this.removeUnitFromCurrentPosition(this.draggedUnit);

    // Adicionar aos não atribuídos
    this.draggedUnit.floor = undefined;
    this.unassignedUnits.push(this.draggedUnit);
    this.unassignedUnits.sort((a, b) =>
      (a.reference || '').localeCompare(b.reference || '')
    );

    this.draggedUnit = null;
  }

  onDragOverAddFloor(event: DragEvent, position: 'top' | 'bottom') {
    if (!this.draggedUnit) return;
    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer!.dropEffect = 'move';

    if (position === 'top') {
      this.showAddFloorTop = true;
    } else {
      this.showAddFloorBottom = true;
    }
  }

  onDragLeaveAddFloor(position: 'top' | 'bottom') {
    // Pequeno delay para evitar flickering ao mover entre elementos
    setTimeout(() => {
      if (position === 'top') {
        this.showAddFloorTop = false;
      } else {
        this.showAddFloorBottom = false;
      }
    }, 100);
  }

  onDropAddFloor(event: DragEvent, position: 'top' | 'bottom') {
    event.preventDefault();
    if (!this.draggedUnit) return;

    const bkpData = this.draggedUnit;
    const oldFloor = this.floors.find(f => f.floorNumber === bkpData?.floor);
    const oldFloorUnits = oldFloor ? [...oldFloor.units] : [];

    // Remover unit da posição anterior
    this.removeUnitFromCurrentPosition(this.draggedUnit);

    // Criar novo andar
    const newFloorNumber = position === 'top'
      ? (Number(this.floors[0]?.floorNumber) || 0) + 1
      : (Number(this.floors[this.floors.length - 1]?.floorNumber) || 0) - 1;

    const newFloor: FloorModel = {
      floorNumber: newFloorNumber,
      units: []
    };

    this.draggedUnit.floor = newFloorNumber;
    newFloor.units.push(this.draggedUnit);

    if (position === 'top') {
      this.floors.unshift(newFloor);
    } else {
      this.floors.push(newFloor);
    }

    this.propertiesService.updateUnitFloor(this.draggedUnit.id, newFloorNumber).subscribe({
      next: () => {
        this.draggedUnit = null;
        this.showAddFloorTop = false;
        this.showAddFloorBottom = false;
      },
      error: () => {
        // Restaurar unit para o piso anterior
        if (oldFloor) {
          oldFloor.units = oldFloorUnits;
          const unitIndex = newFloor.units.findIndex(u => u.id === bkpData.id);
          if (unitIndex > -1) {
            newFloor.units.splice(unitIndex, 1);
          }
        } else {
          // Se não havia piso anterior, mover para não atribuídos
          const unitIndex = newFloor.units.findIndex(u => u.id === bkpData.id);
          if (unitIndex > -1) {
            newFloor.units.splice(unitIndex, 1);
          }
          this.draggedUnit!.floor = undefined;
          this.unassignedUnits.push(this.draggedUnit as any);
          this.unassignedUnits.sort((a, b) =>
            (a.reference || '').localeCompare(b.reference || '')
          );
        }

        this.draggedUnit = null;
        this.showAddFloorTop = false;
        this.showAddFloorBottom = false;

        Swal.fire({
          icon: 'error',
          title: this.translate.instant('t-property-preview.t-error-updating-unit-floor')
          // text: this.translate.instant('t-m-properties.t-error-updating-unit-floor')
        });
      }
    });

  }

  removeUnitFromCurrentPosition(unit: UnitModel) {
    // Remover dos não atribuídos
    const unassignedIndex = this.unassignedUnits.findIndex(u => u.id === unit.id);
    if (unassignedIndex > -1) {
      this.unassignedUnits.splice(unassignedIndex, 1);
      return;
    }

    // Remover de algum andar
    for (const floor of this.floors) {
      const unitIndex = floor.units.findIndex(u => u.id === unit.id);
      if (unitIndex > -1) {
        floor.units.splice(unitIndex, 1);
        return;
      }
    }
  }

  // removeFloor(floor: FloorModel) {
  //   // Mover todas as units para não atribuídos
  //   floor.units.forEach(unit => {
  //     unit.floor = undefined;
  //     this.unassignedUnits.push(unit);
  //   });

  //   this.unassignedUnits.sort((a, b) =>
  //     (a.reference || '').localeCompare(b.reference || '')
  //   );

  //   // Remover andar
  //   const index = this.floors.findIndex(f => f.floorNumber === floor.floorNumber);
  //   if (index > -1) {
  //     this.floors.splice(index, 1);
  //   }
  // }

  getFloorLabel(floorNumber: number): string {
    floorNumber = Number(floorNumber);
    if (floorNumber === 0) return 'R/C';
    if (floorNumber > 0) return `${floorNumber}º Andar`;
    return `Cave ${Math.abs(floorNumber)}`;
  }

  // Normalizar/interpretar o número do piso a partir de diferentes formatos
  parseFloorNumber(floorLabel: string): number | null {
    if (!floorLabel || typeof floorLabel !== 'string') return null;

    const label = floorLabel.trim().toUpperCase();

    // Casos especiais para R/C (Rés do Chão / Ground Floor)
    if (/^R[\/-]?C|RES\s*DO\s*CH|^0$|PISO\s*0|GROUND|ENTRADA/.test(label)) {
      return 0;
    }

    // Casos especiais para Cave/Subsolo (valores negativos)
    if (/^CAVE|SUBSOLO|SUB-SOLO|-1$|-2$/.test(label)) {
      // Tentar extrair número
      const caveMatch = label.match(/-(\d+)|CAVE\s*(\d+)|SUB[A-Z\-]*\s*(\d+)/);
      if (caveMatch) {
        const num = caveMatch[1] || caveMatch[2] || caveMatch[3];
        return -parseInt(num, 10);
      }
      // Default para primeira cave
      return -1;
    }

    // Tentar extrair número positivo (ex: "1º ANDAR", "2 DIREITO", "3ª", etc)
    const numberMatch = label.match(/^(\d+)/);
    if (numberMatch) {
      return parseInt(numberMatch[1], 10);
    }

    // Se for apenas uma letra/número no final
    const singleMatch = label.match(/(\d+)$/);
    if (singleMatch) {
      return parseInt(singleMatch[1], 10);
    }

    return null;
  }

  // Enriquecer o unit com informações do piso quando for arrastado
  enrichUnitWithFloorInfo(unit: UnitModel, newFloorNumber: number) {
    // Se o unit tem referência, complementar com informação do piso
    if (unit.reference) {
      const floorNum = this.parseFloorNumber(unit.reference);

      // Se a referência não tem número de piso claro, adicionar
      if (floorNum === null) {
        unit.reference = `${unit.reference} - ${this.getFloorLabel(newFloorNumber)}`;
      }
    }
  }


  getStatusBadgeClass(status: string): string {
    const statusMap: { [key: string]: string } = {
      'AVAILABLE': 'badge-soft-success',
      'RESERVED': 'badge-soft-info',
      'SOLD': 'badge-soft-danger',
      'RENTED': 'badge-soft-info',
      'PROSPECTING': 'badge-soft-warning'
    };
    return statusMap[status] || 'badge-soft-secondary';
  }

  isUnitInProposal(unit: UnitModel): boolean {
    const unitStatusCode = (unit?.status?.code || '').toUpperCase();
    if (['RESERVED', 'SOLD', 'RENTED'].includes(unitStatusCode)) {
      return false;
    }

    const proposalStatusCode = (unit?.latestProposalStatusCode || '').trim().toLowerCase();
    if (!proposalStatusCode) {
      return false;
    }

    return !['declined', 'DECLINED'].includes(proposalStatusCode);
  }

  shouldShowInProposalLegend(): boolean {
    const floorUnits = this.floors.reduce((acc: UnitModel[], floor) => {
      acc.push(...floor.units);
      return acc;
    }, []);
    const currentUnits = [...floorUnits, ...this.unassignedUnits];
    return currentUnits.some((unit) => this.isUnitInProposal(unit));
  }

  getStores(role: any, val: boolean) {
    if (role === 'STORE OPERATOR') {
      if (val) {
        if (!this.allDistricts || this.allDistricts.length === 0) {
          this.propertiesService.getDistrictsByNetwork().subscribe((data: any) => {
            this.allDistricts = data;
            this.districts = data;
          });
        } else {
          this.districts = this.allDistricts;
        }
      } else {
        this.districts = this.districtsAux;
      }
    }
  }

  onUnitClick(property: any) {
    this.eventService.broadcast('open-fraction-preview-by-dev', property.id);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}

